export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Il tuo ordine è stato visualizzato',
    order_confirmed: '#{{number}} Orario confermato {{time}}',
    order_preparation_up_time_changed: '#{{number}} Orario {{type}} cambiato a {{time}}',
    order_preparing: 'Il tuo ordine #{{number}} è in preparazione',
    order_rejected: 'Ordine #{{number}} rifiutato',
  },
  order_type: {
    pickup: 'Ritiro',
    delivery: 'Consegna',
  },
};
